var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event-details"},[(_vm.isLoading)?_vm._t("loading",[_c('b-spinner',{staticClass:"mx-auto mt-3 d-block",attrs:{"type":"grow","small":""}})]):_vm._t("default",null,{"model":_vm.model})],2)}
var staticRenderFns = []

export { render, staticRenderFns }